import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { default as React, useEffect, useState } from "react";
import "../../Modal/Modal.css";
import {
  addHL7Config,
  getRouterConfigs,
  updateHL7Node,
} from "../../utilities/HL7utils";
import ConfigPartOne from "./ConfigPartOne";
import ConfigPartThree from "./ConfigPartThree";
import ConfigPartTwo from "./ConfigPartTwo";
import ConfigPartFour from "./ConfigPartFour";
import SummaryConfigs from "./SummaryConfigs";

const HL7ConfigModal = (props) => {
  const { modalState, handleClose, setUpdate, title, edit } = props;
  const styles = {
    modalStyles: {
      color: "white",
      position: "absolute",
      top: 0,
      right: 0,
      width: "30%",
      padding: "2rem",
      height: "100vh",
      backdropFilter: "blur(14.5px)",
      background: "transparent",
      boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
    },
    colors: {
      primary75: "white",
      primary50: "white",
      primary25: "white",
      danger: "#DE350B",
      dangerLight: "#FFBDAD",
      neutral0: "black",
      neutral5: "hsl(0, 0%, 95%)",
      neutral10: "hsl(0, 0%, 90%)",
      neutral20: "hsl(0, 0%, 80%)",
      neutral30: "hsl(0, 0%, 70%)",
      neutral40: "hsl(0, 0%, 60%)",
      neutral50: "hsl(0, 0%, 50%)",
      neutral60: "hsl(0, 0%, 40%)",
      neutral70: "hsl(0, 0%, 30%)",
      neutral80: "white",
      neutral90: "hsl(0, 0%, 10%)",
    },
    controlStyles: {
      width: "100%",
      backgroundColor: "#121C1B",
      color: "white",
      zIndex: 9999,
      border: "1px solid #0f9077",
      boxShadow: "0 0 1px rgba(0, 0, 0, 0)",
      "&:hover": {
        border: "1px solid #0f9077",
      },
    },
  };

  const [serverConfig, setServerConfig] = useState({
    segments: [{ segment_name: "", field_number: "" }],
  });
  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [routerConfigs, setRouterConfigs] = useState([]);
  const [config, setConfig] = useState(null);
  const [uid, setUid] = useState(null);
  const [configDetails, setconfigDetails] = useState("");
  const [operation, setOperation] = useState(null);
  const [updatedConfig, setUpdatedConfig] = useState();
  const [step, setStep] = useState(0);
  const [payload, setPayload] = useState();
  const [summary, setSummary] = useState();
  const [segment, setSegment] = useState();
  const [fetchType, setFetchType] = useState("CGET");
  const [cFindChecked, setCFindChecked] = useState(false);
  const [operationPayload, setOperationPayload] = useState(false);
  const [filters, setFiltersPayload] = useState([]);
  const [modality, setModality] = useState(false);
  const [modalityMultiselect, setModalityMultiselect] = useState([]);
  const [reportAutoNode, setReportAutoNode] = useState();
  const [worklistPriorNode, setWorklistPriorNode] = useState();
  const [criticalFindNode, setCriticalFindNode] = useState();
  const [reportAuto, setReportAuto] = useState(false);
  const [worklistPrior, setWorklistPrior] = useState(false);
  const [criticalFind, setCriticalFind] = useState(false);
  const [aiStatusNode, setAiStatusNode] = useState();
  const [aiStatus, setAiStatus] = useState(false);

  const [formIsValid, setFormIsValid] = useState(false);

  const settingFetch = (e) => {
    setFetchType(e);
  };

  useEffect(() => {
    const temp = {};
    let tempSummary = {};
    temp.config_name = serverConfig?.name?.trim();
    temp.segments = serverConfig?.segments;
    temp.unique_identifier_type = uid?.value;
    temp.router_configuration = config?.value;
    temp.operation = operationPayload;
    temp.receive_from = serverConfig?.source?.trim();
    temp.config_details = configDetails;

    if (cFindChecked === true && operation?.value === "qr")
      temp.filters = filters;

    const push_back_nodes = [];
    const push_back_nodes_summary = [];
    if (reportAuto === true)
      push_back_nodes.push({
        operation_name: "Report Auto Population",
        node: reportAutoNode?.value,
      });
    push_back_nodes_summary.push({
      operation_name: "Report Auto Population",
      node: reportAutoNode?.label,
    });
    if (criticalFind === true)
      push_back_nodes.push({
        operation_name: "Critical Findings",
        node: criticalFindNode?.value,
      });
    push_back_nodes_summary.push({
      operation_name: "Critical Findings",
      node: criticalFindNode?.label,
    });
    if (worklistPrior === true)
      push_back_nodes.push({
        operation_name: "Worklist Prioritization",
        node: worklistPriorNode?.value,
      });
    push_back_nodes_summary.push({
      operation_name: "Worklist Prioritization",
      node: worklistPriorNode?.label,
    });
    if(aiStatus === true)
      push_back_nodes.push({
        operation_name: "AI Status",
        node: aiStatusNode?.value,
      });
    push_back_nodes_summary.push({
        operation_name: "AI Status",
        node: aiStatusNode?.label,
      });
    temp.push_back_nodes = push_back_nodes;

    tempSummary = {
      ...temp,
      push_back_nodes: push_back_nodes_summary,
      router_configuration: config?.label,
    };

    setPayload(temp);
    setSummary(tempSummary);
  }, [
    serverConfig,
    operationPayload,
    config,
    filters,
    reportAutoNode,
    reportAuto,
    worklistPriorNode,
    criticalFind,
    criticalFindNode,
    worklistPrior,
    uid,
    configDetails,
    aiStatusNode,
    aiStatus,
  ]);

  const valuesFromSelect = (options) => {
    return options.map((ins) => ins.value);
  };

  useEffect(() => {
    const temp = null;
    const temp2 = [];
    if (operation?.value === "Filter") {
      setOperationPayload("Filter");
    } else {
      if (cFindChecked === true) {
        temp2.push({
          tag_id: "modality",
          value: valuesFromSelect(modalityMultiselect),
        });
      }

      setOperationPayload(fetchType);
      setFiltersPayload(temp2);
    }
  }, [fetchType, operation, modalityMultiselect, cFindChecked]);

  useEffect(() => {
    const temp = {};
    temp.name = serverConfig?.name;
    temp.uidType = serverConfig?.uidType;
    temp.name = serverConfig?.name;
    temp.name = serverConfig?.name;
  }, [serverConfig]);

  useEffect(() => {
    const getRouterConfig = async () => {
      try {
        const data = await getRouterConfigs();
        setRouterConfigs(data);
      } catch (error) {
        console.error(error);
      }
    };

    getRouterConfig();
  }, []);

  useEffect(() => {
    const noErrors = Object.values(errors).every((error) => error === "");
    const allFieldsFilled = ["name", "ip", "port"].every(
      (field) => serverConfig[field]
    );

    setIsFormValid(noErrors && allFieldsFilled && config?.label);
  }, [errors, serverConfig]);

  const configChange = (selectedOption, configKey) => {
    const value = selectedOption?.value || "";

    console.log("configKey", configKey);

    setServerConfig((prevConfig) => ({
      ...prevConfig,
      [configKey]: value,
    }));
    validate(configKey, value);
  };

  const dropdownOptions = routerConfigs?.map((option) => ({
    label: option?.config_name,
    value: option?.id,
  }));

  const validate = (name, value) => {
    let errorMsg = "";
    switch (name) {
      case "config_name":
        if (!value) errorMsg = "Config Name is required.";
        break;
      case "operation":
        if (!value) errorMsg = "Operation is required.";
        break;

      default:
        break;
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMsg,
    }));
    return errorMsg === "";
  };

  const fetchData = async (serverConfig) => {
    if (title.toLowerCase() === "edit") {
      try {
        const data = await updateHL7Node(updatedConfig);
        setResponseData(data);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const data = await addHL7Config(payload);
        setResponseData(data);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleClick = (param) => {
    if (param === "submit") {
      const isValidName = validate("name", serverConfig.name);
      const isValidIp = validate("ip", serverConfig.ip);
      const isValidPort = validate("port", serverConfig.port);
      const isValidVersion = validate("version", config?.value);
      if (isValidName && isValidIp && isValidPort && isValidVersion) {
        fetchData(serverConfig);
        setUpdate(true);
        handleClose();
      } else {
        console.log("Validation failed");
      }
    } else if (param === "next") {
      if (step === 4) {
        return;
      } else setStep(step + 1);
    } else {
      if (step === 0) {
        return;
      } else setStep(step - 1);
    }
  };

  const handleSegmentChange = (index, field, value) => {
    if (field === "field_number") {
      value = +value;
    }
    const newSegments = serverConfig.segments.map((segment, i) => {
      if (i === index) {
        return { ...segment, [field]: value };
      }
      return segment;
    });

    setServerConfig((prevConfig) => ({
      ...prevConfig,
      segments: newSegments,
    }));
    validate(field, value);
  };

  const addSegment = () => {
    setServerConfig((prevConfig) => ({
      ...prevConfig,
      segments: [
        ...prevConfig.segments,
        { segment_name: "", field_number: "" },
      ],
    }));
  };

  const deleteSegment = (index) => {
    setServerConfig((prevConfig) => ({
      ...prevConfig,
      segments: prevConfig.segments.filter((_, i) => i !== index),
    }));
  };

  const handleMultiSelect = (selectedList) => {
    const updatedArray = selectedList.map((item) => ({
      id: item.id,
      name: item.name,
    }));
    setModalityMultiselect(updatedArray);
  };

  const onSelect = (selectedList) => {
    var dummyarray = [];
    selectedList.map((items) => {
      dummyarray.push({
        value: items.value,
        label: items.label,
      });
    });
    setModalityMultiselect(dummyarray);
  };

  const onRemove = (selectedList) => {
    var dummyarray = [];
    selectedList.map((items) => {
      dummyarray.push({
        value: items.value,
        label: items.label,
      });
    });
    setModalityMultiselect(dummyarray);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.startsWith("segment_name-") || name.startsWith("field_number-")) {
      const [field, index] = name.split("-");
      handleSegmentChange(parseInt(index, 10), field, value);
    } else {
      setServerConfig((prevConfig) => ({
        ...prevConfig,
        [name]: value,
      }));
      validate(name, value);
    }
  };

  return (
    <div>
      <Modal
        className="Backdrop"
        open={modalState}
        onClose={handleClose}
        sx={{ width: "300", background: "transparent" }}
      >
        <Box sx={styles.modalStyles}>
          <div className="d-flex justify-content-between ">
            <div className="h5 font-weight-bold mt-2">
              {title} HL7 Configuration
            </div>
            <div className=" ">
              <IconButton
                className="text-light"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          {step === 0 ? (
            <ConfigPartOne
              serverConfig={serverConfig}
              handleChange={handleChange}
              handleClick={handleClick}
              styles={styles}
              step={step}
              dropdownOptions={dropdownOptions}
              configChange={configChange}
              isFormValid={isFormValid}
              config={config}
              setConfig={setConfig}
              setUid={setUid}
              uid={uid}
              segment={segment}
              setSegment={setSegment}
              addSegment={addSegment}
              deleteSegment={deleteSegment}
              errors={errors}
              formIsValid={formIsValid}
            />
          ) : step === 1 ? (
            <ConfigPartTwo
              handleClick={handleClick}
              styles={styles}
              step={step}
              isFormValid={isFormValid}
              setOperation={setOperation}
              operation={operation}
              fetchType={fetchType}
              cFindChecked={cFindChecked}
              setCFindChecked={setCFindChecked}
              setFetchType={settingFetch}
              modalityMultiselect={modalityMultiselect}
              onSelect={onSelect}
              onRemove={onRemove}
              errors={errors}
            />
          ) : step === 2 ? (
            <ConfigPartThree
              handleClick={handleClick}
              styles={styles}
              step={step}
              isFormValid={isFormValid}
              reportAutoNode={reportAutoNode}
              setReportAutoNode={setReportAutoNode}
              worklistPriorNode={worklistPriorNode}
              setWorklistPriorNode={setWorklistPriorNode}
              criticalFindNode={criticalFindNode}
              setCriticalFindNode={setCriticalFindNode}
              reportAuto={reportAuto}
              setReportAuto={setReportAuto}
              worklistPrior={worklistPrior}
              setWorklistPrior={setWorklistPrior}
              criticalFind={criticalFind}
              setCriticalFind={setCriticalFind}
              aiStatusNode={aiStatusNode}
              setAiStatusNode={setAiStatusNode}
              aiStatus={aiStatus}
              setAiStatus={setAiStatus}
              errors={errors}
            />
          ) : step === 3 ? (
            <ConfigPartFour
              handleClick={handleClick}
              styles={styles}
              step={step}
              configDetails={configDetails}
              setconfigDetails={setconfigDetails}
              errors={errors}
            />
          ) : (
            <SummaryConfigs
              payload={payload}
              summary={summary}
              errors={errors}
              validate={validate}
              step={step}
              handleClick={handleClick}
            />
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default HL7ConfigModal;
